import { isTerminalTaskStatus } from '@erp/shared-types';

export function isPricelistCaseOpen(task: {
  status: string;
  taskDeleted: boolean;
}): boolean {
  return !isTerminalTaskStatus(task.status) && !task.taskDeleted;
}
